<script setup>
defineProps({
    modelValue: {type: [Number, String], default: 0},
});

const emit = defineEmits(["update:modelValue", "input"]);
const updateValue = (value) => {
    if (value !== "") {
        emit("update:modelValue", value);
    }
}
</script>
<template>
  <span>
    <button
        class="cursor-pointer bg-gray-200 d-none d-sm-inline"
        @click="updateValue(modelValue > 0 ? modelValue - 1 : null)"
    >
      -
    </button>
    <input :value="modelValue" type="number" min="0" @input="updateValue($event.target.value)" class="input"/>
    <button
        class="bg-gray-200 cursor-pointer d-none d-sm-inline"
        @click="updateValue(modelValue + 1)"
    >
      +
    </button>
  </span>
</template>

<style scoped>
button {
    background-color: white;
    padding: 0 6px;
    margin: 0;
    border: 0;
    height: 1.875rem;
    width: 1.875rem;
}

input {
    border: 1px solid black;
    width: 2.5rem;
    outline: 0;
    text-align: center;
    box-sizing: border-box;
    -webkit-box-align: center;
    align-items: center;
    height: 1.875rem;
    font-size: 1rem;
    letter-spacing: 0;
    line-height: 1.5rem;
    font-family: Roboto, sans-serif;
    font-weight: 400;
}
@media (max-width: 575.98px) {
    input {
        width: 1.5rem;
        font-size: .8rem;
        height: 1.5rem;
    }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>
